import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { GrnReturnAutoFillDto } from './grn-return-auto-fill.dto';


export class GrnReturnAutoFillModel extends GlobalResponseObject {
    data?: GrnReturnAutoFillDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: GrnReturnAutoFillDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

